import { z } from 'zod';
import { SHIP_TERMS_CONSTRAINTS } from './constraints.js';
export const updateShipTermsInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${SHIP_TERMS_CONSTRAINTS.name.label} cannot be empty.`)
        .max(SHIP_TERMS_CONSTRAINTS.name.maxLength)
        .optional(),
});
//# sourceMappingURL=update-input.js.map